import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Select from "react-select";
import Loader from "react-spinner-loader";
import * as Yup from "yup";
import { callGetCity, callGetState } from "../../http/fundLync/entityAndAddress.helper";
import {
    Button,
    Card,
    CardBody,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormFeedback,
    Input,
    Label,
    Row,
    Table,
    UncontrolledDropdown,
    UncontrolledTooltip,
} from "reactstrap";
import { isPermission, uId } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import {
    addAddress,
    editAddress,
    getAddress,
} from "http/fundLync/entityAndAddress.helper";

const PartnerAddressDetails = () => {
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [isAddAddressOpen, setAddAddressOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [loader, setLoader] = useState(false);
    const [stateList, setState] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [addressList, setaddressList] = useState([]);
    const [entity, setAddress] = useState(null);
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [isNewAddressPermission, setNewAddressPermission] = useState(false);
    const [isEditAddressPermission, setEditAddressPermission] = useState(false);

    const urlParams = new URLSearchParams(window.location.search);
    const encodedId = urlParams.get("id");
    const entityId = atob(encodedId);

    // validation
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            addressType: (entity && entity[0].addressType) || "",
            address1: (entity && entity[0].address1) || "",
            address2: (entity && entity[0].address2) || "",
            address3: (entity && entity[0].address3) || "",
            state: (entity && entity[0].state.toUpperCase()) || "",
            city: (entity && entity[0].city.toUpperCase()) || "",
            pincode: (entity && entity[0].pincode) || "",
            id: (entity && entity[0].id) || "",
        },
        validationSchema: Yup.object({
            address1: Yup.string().required("Please Enter Address line 1"),
            address2: Yup.string(),
            address3: Yup.string(),
            city: Yup.string().required("Please Enter City"),
            state: Yup.string().required("Please Enter State"),
            pincode: Yup.number()
                .required("Please Enter Pincode")
                .typeError("Pincode Must be a Number")
                .positive("Pincode must be a positive number")
                .integer("Pincode must be an integer")
                .test('len', 'Pincode must be exactly 6 digits', val => val && val.toString().length === 6),
            addressType: Yup.string().required("Address Type is Required"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                const entity = {
                    id: values.id,
                    addressType: values.addressType,
                    address1: values.address1,
                    address2: values.address2,
                    address3: values.address3,
                    state: values.state,
                    city: values.city,
                    pincode: values.pincode,
                    entityId,
                };
                editAddress(entity)
                    .then((response) => {
                        if (response.code == 201 && response.status) {
                            setToastInfo({
                                message: "Address Saved",
                                showToast: true,
                                role: "success",
                            })
                            callAddressAfterSave();
                            setAddAddressOpen(false);
                        } else {
                            const { message } = response;
                            setToastInfo({
                                message: message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                const entity = {
                    address1: values.address1,
                    address2: values.address2 || "",
                    address3: values.address3 || "",
                    city: values.city,
                    state: values.state,
                    pincode: values.pincode,
                    addressType: values.addressType,
                    entityId,
                };
                addAddress(entity)
                    .then((response) => {
                        if (response.code == 201 && response.status) {
                            setToastInfo({
                                message: "Address Saved",
                                showToast: true,
                                role: "success",
                            });
                            callAddressAfterSave();
                            setAddAddressOpen(false);
                        } else {
                            const { message } = response;
                            setToastInfo({
                                message: message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }

            validation.resetForm();
        },
    });

    useEffect(() => {
        getAddress({ entityId })
            .then((response) => {
                setaddressList(response.data.data);
            })
            .catch((error) => {
                console.error(error);
            });
        callGetState()
            .then((response) => {
                if (response.code == "200") {
                    setState(response.data);
                }
            })
            .catch((error) => { });

        checkPermissions();
    }, []);

    const checkPermissions = async () => {
        const isAddpermission = await isPermission("address", "create_permission");
        const editAddressPermission = await isPermission("address", "edit_permission");
        setNewAddressPermission(isAddpermission);
        setEditAddressPermission(editAddressPermission);
    };

    const handleCustomerClicks = () => {
        setAddAddressOpen(true);
        setIsEdit(false);
        setAddress(null);
    };

    const handleCancelrClicks = () => {
        validation.resetForm();
        setAddAddressOpen(false);
        setAddress(null);
    };

    const EditAddress = (id) => {
        setIsEdit(true);
        const filteredData = addressList.filter((elem) => {
            return elem.id == id;
        });
        if (filteredData.length > 0) {
            getCityList(filteredData[0]?.state)
        }
        setAddress(filteredData);
        setAddAddressOpen(true);
    };

    function setStateValue(data, state) {
        if (state) {
            for (const item of data) {
                if (item.name === state) {
                    const value = { label: `${item.name}`, value: state };
                    return value;
                }
            }
        }
    }

    function setCityValue(data, city) {
        if (city) {
            for (const item of data) {
                if (item.cityName === city) {
                    const value = { label: `${item.cityName}`, value: city };
                    return value;
                }
            }
        } else {
            return null
        }
    }

    const handleInputChange = (value) => {
        validation.setFieldValue("state", value);
        validation.setFieldValue("city", "")
        getCityList(value)
    };

    const handleCityChange = (value) => {
        validation.setFieldValue("city", value);
    };

    const getCityList = (value) => {
        callGetCity({ state: value })
            .then((response) => {
                if (response.status) {
                    setCityList(response?.data)
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
        setAddAddressOpen(false);
        setIsEdit(false);
    };

    const callAddressAfterSave = () => {
        getAddress({ entityId })
            .then((response) => {
                setaddressList(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <React.Fragment>
            <div>
                <Card style={{ padding: "10px" }}>
                    <div
                        className="d-flex justify-content-between mt-1"
                        style={{ cursor: "pointer" }}
                        onClick={toggleDropdown}
                    >
                        <div>
                            <h5>Address</h5>
                        </div>
                        <div className="me-2">
                            <i
                                className={`fas fa-angle-${isDropdownOpen ? "up" : "down"}`}
                                style={{ fontSize: "20px" }}
                            ></i>
                        </div>
                    </div>
                    {isAddAddressOpen && (
                        <Card>
                            <CardBody>
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}
                                >
                                    <Row className="mb-3">
                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">
                                                Address Type *
                                            </Label>
                                            <Input
                                                name="addressType"
                                                type="select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.addressType || ""}
                                                invalid={
                                                    validation.touched.addressType &&
                                                        validation.errors.addressType
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="" disabled>
                                                    Select address type
                                                </option>
                                                <option value="registered_business_address">
                                                    Registered Business Address
                                                </option>
                                                <option value="head_office_address">
                                                    Head Office Address
                                                </option>
                                            </Input>
                                            {validation.touched.addressType &&
                                                validation.errors.addressType ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.addressType}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">
                                                Address Line1 *
                                            </Label>
                                            <Input
                                                name="address1"
                                                type="text"
                                                placeholder="Insert Address Line1"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.address1 || ""}
                                                invalid={
                                                    validation.touched.address1 &&
                                                        validation.errors.address1
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {validation.touched.address1 &&
                                                validation.errors.address1 ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.address1}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">Address Line2</Label>
                                            <Input
                                                name="address2"
                                                type="text"
                                                placeholder="Insert Address Line2"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.address2 || ""}
                                                invalid={
                                                    validation.touched.address2 &&
                                                        validation.errors.address2
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {validation.touched.address2 &&
                                                validation.errors.address2 ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.address2}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">Address Line3</Label>
                                            <Input
                                                name="address3"
                                                type="text"
                                                placeholder="Insert Address Line3"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.address3 || ""}
                                                invalid={
                                                    validation.touched.address3 &&
                                                        validation.errors.address3
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {validation.touched.address3 &&
                                                validation.errors.address3 ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.address3}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">State*</Label>
                                            <Select
                                                options={stateList.map((option, index) => ({
                                                    label: option.name,
                                                    value: option.name,
                                                }))}
                                                className={`${validation.touched.state && validation.errors.state
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}
                                                name="state"
                                                id="state"
                                                onChange={(selectedOption) => {
                                                    handleInputChange(selectedOption.value);
                                                }}
                                                value={setStateValue(
                                                    stateList,
                                                    validation.values.state
                                                )}
                                            />
                                            {validation.touched.state &&
                                                validation.errors.state && (
                                                    <FormFeedback>
                                                        {validation.errors.state}
                                                    </FormFeedback>
                                                )}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">City*</Label>
                                            <Select
                                                options={cityList.map((option) => ({
                                                    label: option.cityName,
                                                    value: option.cityName,
                                                }))}
                                                className={`select-dropdown ${validation.touched.city && validation.errors.city
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}
                                                name="city"
                                                id="city"
                                                onChange={(selectedOption) => {
                                                    handleCityChange(selectedOption.value);
                                                }}
                                                value={setCityValue(
                                                    cityList,
                                                    validation.values.city
                                                )}
                                            />
                                            {validation.touched.city && validation.errors.city ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.city}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>

                                        <Col sm="12" md="6">
                                            <Label className="form-label mt-4">Pincode*</Label>
                                            <Input
                                                name="pincode"
                                                type="text"
                                                placeholder="Insert pincode"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.pincode || ""}
                                                invalid={
                                                    validation.touched.pincode &&
                                                        validation.errors.pincode
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {validation.touched.pincode &&
                                                validation.errors.pincode ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.pincode}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger save-customer me-2"
                                                    onClick={handleCancelrClicks}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success save-customer"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    )}
                    {isDropdownOpen && (
                        <Row>
                            <div className="text-sm-end">
                                {isNewAddressPermission && (
                                    <Button
                                        type="button"
                                        color="success"
                                        className="btn-rounded mb-2 me-2"
                                        onClick={handleCustomerClicks}
                                    >
                                        <i className="mdi mdi-plus me-1" />
                                        New Address
                                    </Button>
                                )}
                            </div>
                            <Col xs="12" className="mt-1 mb-2">
                                <div className="table-responsive">
                                    <Table className="table table-bordered table-striped mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Id</th>
                                                <th>Address</th>
                                                <th>Address Type</th>
                                                <th>City</th>
                                                <th>State</th>
                                                <th>Pincode</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {addressList.length == 0 ? (
                                                <tr>
                                                    <td colSpan={7} className="text-center">
                                                        No data found
                                                    </td>
                                                </tr>
                                            ) : (
                                                addressList.map((elem, index) => (
                                                    <tr key={uId()}>
                                                        <td>{index + 1}</td>
                                                        <td>{elem.address1}</td>
                                                        <td>
                                                            {elem.addressType == "head_office_address"
                                                                ? "Head Office Address"
                                                                : "Registered Business Address"}
                                                        </td>
                                                        <td>{elem.city}</td>
                                                        <td>{elem.state}</td>
                                                        <td>{elem.pincode}</td>
                                                        <td>
                                                            <UncontrolledDropdown>
                                                                <DropdownToggle
                                                                    tag="a"
                                                                    className="card-drop"
                                                                >
                                                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                                                </DropdownToggle>

                                                                {isEditAddressPermission && <DropdownMenu className="dropdown-menu-end">
                                                                    <DropdownItem
                                                                        onClick={() => {
                                                                            EditAddress(elem.id);
                                                                        }}
                                                                    >
                                                                        <i
                                                                            className="mdi mdi-pencil font-size-16 text-success me-1"
                                                                            id="edittooltip"
                                                                        ></i>
                                                                        Edit
                                                                        <UncontrolledTooltip
                                                                            placement="top"
                                                                            target="edittooltip"
                                                                        >
                                                                            Edit
                                                                        </UncontrolledTooltip>
                                                                    </DropdownItem>
                                                                </DropdownMenu>}
                                                            </UncontrolledDropdown>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                    )}
                </Card>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
            <Loader show={loader} type="box" message="Fetching Data" />
        </React.Fragment>
    );
};


export default PartnerAddressDetails
